import { Component, OnDestroy } from '@angular/core';

import { FieldBaseComponent } from '../base-component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { Subscription, isObservable } from 'rxjs';

@Component({
  selector: 'app-lib-ff-select',
  styleUrls: ['./select.component.scss'],
  templateUrl: './select.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
  ],
})
export class FormlySelectFieldComponent extends FieldBaseComponent implements OnDestroy {
  private optionsSubscription: Subscription | null = null;
  private resolvedOptions: any[] = [];

  public defaultOptions = {
    props: { options: [] },
  };

  public optionsList(): any[] {
    const options = this.props?.options;

    if (Array.isArray(options)) {
      return options;
    }

    if (isObservable(options)) {
      if (!this.optionsSubscription) {
        this.optionsSubscription = options.subscribe((nextOptions) => {
          this.resolvedOptions = Array.isArray(nextOptions) ? nextOptions : [];
        });
      }
      return this.resolvedOptions;
    }

    return [];
  }

  public ngOnDestroy(): void {
    this.optionsSubscription?.unsubscribe();
  }
}
